export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-bluetooth-62b95ae00fe43f1f823625310bdca73a.svg";